import { Routes } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { BillPayComponent } from './components/bill-pay/bill-pay.component';
import { IntegratedReviewsComponent } from './components/integrated-reviews/integrated-reviews.component';
import { ReferralRequestComponent } from './components/referral-request/referral-request.component';
import { PortalLayoutComponent } from './layout/portal-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { billPayGuard } from './core/guards/bill-pay.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: PortalLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'bill-pay', component: BillPayComponent, canActivate: [billPayGuard] },
      { path: 'integrated-reviews', component: IntegratedReviewsComponent },
      { path: 'referral-request', component: ReferralRequestComponent },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
